import React, { useEffect, useState } from 'react';
import bemCn from 'bem-cn';
import SvgDog from 'src/assets/svg/SvgDog.svg';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import './style.scss';

const b = bemCn('designed-for-private-comp');

const title = 'Designed for private play';
const subtitle = 'Only the people and dogs in your booking are allowed in the spot during your visit.';

const DesignedForPrivate = ({ banner = false, home }) => {
    const isMobile = useMobileScreen();
    const [lineBreak, setLineBreak] = useState(true);

    useEffect(() => {
        setLineBreak(isMobile);
    }, [isMobile]);

    return (
        <div className={b.mix(banner ? 'private-banner' : '')}>
            <SvgDog className={b('icon')} />
            <div className={b('content')}>
                {home ? (
                    <p className={b('home-title')}>
                        <span>Get free credits to try Sniffspot risk-free for 7 days.</span>
                        {lineBreak ? <br /> : ' '}No commitments, just zoomies.
                    </p>
                ) : (
                    <p className={b('title')}>
                        {title}
                        {banner ? '. ' : ''}
                    </p>
                )}
                {!home && <p className={b('subtitle')}>{subtitle}</p>}
            </div>
        </div>
    );
};

export default DesignedForPrivate;
